export default __webpack_public_path__ + "static/media/Novotril-0.5-eng.defae924.jpg";